import axios from 'axios';

const api  = axios.create(
    {
        baseURL: "https://chat.novaxs.com.br/api/v1",
    }
)

export default api;